let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gcjx2")).then(() => parcelRequire('38Ys8'));